import styled from 'styled-components';
import {Person, Role, Scope, StyledBaseProps} from "@betrue/shared/interfaces";
import {Avatar, Menu, MenuItem} from "@material-ui/core";
import React, {useState} from "react";
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {MenuAvatarProps} from "@betrue/ui";
import {personAvatarUrl} from "@betrue/front/services";

export interface MenuAvatarViewProps extends MenuAvatarProps, StyledBaseProps {
  person: Person
  onLogOut: () => void

}

export const MenuAvatarView = styled((props: MenuAvatarViewProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  return (<div className={props.className}>
      <Avatar alt={`${props.person.firstName} ${props.person.lastName}`}
              src={personAvatarUrl(props.person)}
              onClick={(e) => handleClick(e)}>
        {
          props.person.firstName && props.person.lastName ?
            props.person.firstName[0] + props.person.lastName[0] :
            '??'
        }
      </Avatar>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        disableRestoreFocus={true}
        disableEnforceFocus={true}
        disablePortal={true}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={props.onLogOut}>{props.logoutLabel ? props.logoutLabel : 'Déconnexion'}</MenuItem>
        {props.person.scope === Scope.EMPLOYEE && props.person.role === Role.ADMIN ? (<MenuItem
          onClick={() => window.location.href = props.invoicesUrl ? props.invoicesUrl : '/invoices'}>{props.invoicesLabel ? props.invoicesLabel : 'Factures & Paiements'}</MenuItem>) : ''}
        {props.person.scope === Scope.EMPLOYEE ? (<MenuItem
          onClick={() => window.location.href = props.invoicesUrl ? props.invoicesUrl : '/secrets'}>{props.secretsLabel ? props.secretsLabel : 'Mes secrets'}</MenuItem>) : ''}
        {props.person.scope === Scope.EMPLOYEE ? (<MenuItem
          onClick={() => window.open("https://odoo.betrue.fr", "_blank")}>{props.crmLabel ? props.crmLabel : 'CRM'}</MenuItem>) : ''}

      </Menu>
    </div>
  );
})``

